import type { TableProps } from 'antd';
import { Button, Table } from 'antd';
import type { ReactNode } from 'react';
import React from 'react';
import QuietEmpty from '@/components/QuietEmpty';
import styles from './style.module.less';

type ProductFormSectionProps<RecordType extends object> = {
  title?: ReactNode;
  columns: TableProps<RecordType>['columns'];
  dataSource: readonly RecordType[];
  rowKey: TableProps<RecordType>['rowKey'];
  editingRowKey?: string;
  loading?: boolean;
  emptyText?: ReactNode;
  addButtonText: string;
  onAdd: () => void;
  scroll?: TableProps<RecordType>['scroll'];
  size?: TableProps<RecordType>['size'];
};

export function ProductFormSection<RecordType extends { key?: React.Key }>({
  title,
  columns,
  dataSource,
  rowKey,
  editingRowKey,
  loading,
  emptyText,
  addButtonText,
  onAdd,
  scroll,
  size = 'small',
}: ProductFormSectionProps<RecordType>) {
  return (
    <div className={styles.root}>
      {title ? (
        <div className={styles.toolbar}>
          <div className={styles.toolbarMain}>
            <div className={styles.toolbarTitle}>{title}</div>
          </div>
        </div>
      ) : null}
      <div className={styles.tableWrap}>
        <Table<RecordType>
          rowKey={rowKey}
          columns={columns}
          dataSource={[...dataSource]}
          loading={loading}
          pagination={false}
          size={size}
          scroll={scroll}
          rowClassName={(record) => {
            if (!editingRowKey) {
              return '';
            }
            const currentKey =
              typeof rowKey === 'function'
                ? rowKey(record)
                : String(record[rowKey as keyof RecordType] || '');
            return String(currentKey) === editingRowKey ? 'editingRow' : '';
          }}
          locale={{
            emptyText: <QuietEmpty />,
          }}
        />
      </div>
      <Button className={styles.addRowButton} onClick={onAdd}>
        <span className={styles.addRowButtonText}>{addButtonText}</span>
      </Button>
    </div>
  );
}
